import GeneralToleranceWidgetPage from "../pages/Widgets/Tolerance/General/GeneralToleranceWidgetPage";
import FanToleranceWidgetPage from "../pages/Widgets/Tolerance/Fan/FanToleranceWidgetPage";
import DriveshaftToleranceWidgetPage from "../pages/Widgets/Tolerance/Driveshaft/DriveshaftToleranceWidgetPage";

/**
 * Route sub-tree for embeddable widget pages.
 *
 * Widget pages render without the navigation shell (HomeLayout) so they can be
 * embedded cleanly in iframes on WordPress or other external sites.
 *
 * Mounted under `/:lang?/widgets/` in the main route tree (Root.js).
 *
 * /widgets/tolerance             → GeneralToleranceWidgetPage
 * /widgets/tolerance/general     → GeneralToleranceWidgetPage
 * /widgets/tolerance/fan         → FanToleranceWidgetPage
 * /widgets/tolerance/fans        → FanToleranceWidgetPage  (alias kept for backward compatibility)
 * /widgets/tolerance/driveshaft  → DriveshaftToleranceWidgetPage
 */
const WidgetsRoute = {
    path: "widgets",
    children: [
        {
            path: "tolerance",
            children: [
                {
                    index: true,
                    element: <GeneralToleranceWidgetPage />
                },
                {
                    path: "general",
                    element: <GeneralToleranceWidgetPage />
                },
                {
                    path: "fan",
                    element: <FanToleranceWidgetPage />
                },
                {
                    // Alias for /fan kept because some external embeds already use this URL.
                    path: "fans",
                    element: <FanToleranceWidgetPage />
                },
                {
                    path: "driveshaft",
                    element: <DriveshaftToleranceWidgetPage />
                }
            ]
        }
    ]
};

export default WidgetsRoute;
